/// <reference path="hero.CompositeImageHero.js" />
/// <reference path="hero.ProductImageHero.js" />
/// <reference path="hero.VideoHero.js" />
/*
 * PDP interactions hero, alternate images, and model/size shown
 *
 * Plugin to be initialized on product detail element '.js-pdp-hero-container'
 * i.e. $('.js-pdp-hero-container').heroInteraction();
 *
 */

//maintain a dictionary of active matrix options keyed by matrix type
//(only needed if there is a composite hero image to maintain)
var imageMatrixLookup = {};

(function ($) {
    var selectors = {
        altImageContainer: '.js-pdp-hero-alt-image-container',
        altImageInner: '.js-pdp-hero-alt-image-inner',
        dotContainer: '.js-pdp-hero-dot-container',
        heroContainer: '.js-pdp-hero-container',
        imageContainer: '.js-pdp-hero-image-container',
        imageAssets: '.js-pdp-image-asset',
        matrices: '.js-selection-matrix',
        matrixOptionButtons: '.js-selection-matrix-option-container',
        matrixOptions: '.js-selection-matrix-option',
        modelInfoDetails: '.js-pdp-model-info-details',
        modelInfoClose: '.js-pdp-model-info-close',
        modelInfoContainer: '.js-pdp-model-info-container',
        modelInfoLink: '.js-pdp-hero-model-info-link',
        pdpHeroArrows: '.js-pdp-hero-arrow',
        pdpHeroImage: '.pdp-hero-image',
        zoomLink: '.js-pdp-hero-zoom-link'
    };

    const SWIPE_THRESHOLD = 20;

    //setup all the hero containers on the page
    $.fn.heroInteraction = function () {
        var $container = $(this),
            $heroImageContainer = $container.find(selectors.imageContainer),
            $altImageInner = $container.find(selectors.altImageInner),
            $dotContainer = $container.find(selectors.dotContainer);

        var imageComingSoonSelected = false;

        var initializeForCompositeImages = function (callback) {
            //only do work if there is a composite image on the page
            if (!$heroImageContainer.children(selectors.imageAssets + '[data-mediatype="composite"]').size()) {
                if ($.isFunction(callback)) {
                    callback();
                }
                return;
            }

            //find and group the first matrix options (but by image sequence)
            //to figure out which components images the composite should start with
            $(selectors.matrices).each(function (i, matrix) {
                var minSequence = Number.MAX_VALUE;
                $(matrix).find(selectors.matrixOptions + '[data-imagematrixoptionid]').each(function () {
                    var matrixOptionId = $(this).data('imagematrixoptionid'),
                        img = imagesByMatrixOptionId[matrixOptionId];
                    if (img && img.Sequence < minSequence) {
                        minSequence = img.Sequence;
                        imageMatrixLookup[i] = matrixOptionId;
                    }
                });
            });

            var imageDeferreds = [],
                newImagesByMatrixOptionId = {};
            $.each(imagesByMatrixOptionId, function (matrixOptionId, imgInfo) {
                if (imgInfo && imgInfo.EnlargeImageUrl) {
                    var img = new Image(),
                        def = $.Deferred();
                    img.onload = def.resolve;
                    //need to set crossOrigin to anonymous to avoid
                    //canvas "tainted" security error
                    //more info here: https://stackoverflow.com/questions/20424279/canvas-todataurl-securityerror
                    img.crossOrigin = 'anonymous';
                    img.src = imgInfo.EnlargeImageUrl;
                    imageDeferreds.push(def);
                    newImagesByMatrixOptionId[matrixOptionId] = img;
                }
            });

            //wait until all of the images have finished loading before calling the callback method
            //(Usage of $.when.apply was needed to pass array parameter.
            //See https://stackoverflow.com/questions/5627284/pass-in-an-array-of-deferreds-to-when)
            $.when.apply($, imageDeferreds).done(function () {
                imagesByMatrixOptionId = newImagesByMatrixOptionId;
            }).then(callback);
        };

        initializeForCompositeImages(function () {
            var firstVisibleHero = null;
            $heroImageContainer.children(selectors.imageAssets).each(function (i) {
                var $this = $(this),
                    heroMedia;

                switch ($this.data('mediatype')) {
                    case 'composite':
                        heroMedia = new CompositeImageHero($container, $this);
                        break;
                    case 'image':
                        heroMedia = new ProductImageHero($container, $this);
                        break;
                    case 'video':
                        heroMedia = new VideoHero($container, $this);
                        break;
                    default:
                        console.error('Unknown hero media type: ' + $this.data('mediatype'));
                        break;
                }

                $altImageInner.append(heroMedia.$alternateImage);
                $dotContainer.append(heroMedia.$dot);

                if (!firstVisibleHero && !$this.hasClass('hidden')) {
                    firstVisibleHero = heroMedia;
                }
            });

            if (firstVisibleHero) {
                firstVisibleHero.select();
            }
            $heroImageContainer.removeClass('loading');

            heroArrowsCheck();
            initializeAltContainer();

            //listen for the updateheroimages event that is triggered by a user selecting a matrix option that has an image
            //toggles display of assets based on matching the given matrix option id
            evo.$.body.on('matrixoptionchanged.evo', selectors.matrixOptions, function (e) {
                var $matrixOptionBtn = $(this),
                    matrixOptionId = $matrixOptionBtn.data('imagematrixoptionid');
                if (!matrixOptionId) {
                    return;
                }

                //update the image matrix lookup so that the new matrix option takes its place in the lookup
                var matrixRowNumber = $matrixOptionBtn.closest(selectors.matrices).prevAll(selectors.matrices).size(),
                    $imageAssets = $container.find(selectors.imageAssets);
                imageMatrixLookup[matrixRowNumber] = matrixOptionId;

                //update any composite images
                $imageAssets.filter('[data-mediatype="composite"]').each(function () {
                    var compositeHero = $(this).data('hero-media');
                    compositeHero.updateImage();
                });

                //build a matrix option selector that activates all images
                //for any "active" matrix options
                var matrixOptionSelector = '.js-image-shared';
                $.each(imageMatrixLookup, function (row, optId) {
                    matrixOptionSelector += ',.js-image-matrix-option-' + optId;
                });

                $imageAssets.not(matrixOptionSelector).addClass('hidden');
                $imageAssets.filter(matrixOptionSelector).removeClass('hidden');

                //select the first visible image
                var firstVisibleHeroMedia = $heroImageContainer.children(':not(.hidden)').first().data('hero-media');

                var imageComingSoon = '<img alt="Image Coming Soon" class="js-image-matrix-option image-coming-soon" style="padding-bottom: 0px !important" data-imageid="image-coming-soon" data-mediatype="image" src="https://images.evo.com/imgp/700/_notavailable.jpg">'

                //sets hero image to the first image w/o hidden attribute upon matrix selection
                //if no image is associated with matrix selection, append "Image Coming Soon" img to image container
                if (firstVisibleHeroMedia) {
                    firstVisibleHeroMedia.select();
                } else {
                    if (!imageComingSoonSelected) {
                        $(".pdp-hero-image-container").append(imageComingSoon);
                        $(".pdp-hero-image-container").attr("style", "padding-bottom: 0px !important")
                        imageComingSoonSelected = true;
                    }
                }

                heroArrowsCheck();
            });

            //handler for previous next arrow links, trigger a click on the dots.
            $container.find(selectors.pdpHeroArrows).on('click', function () {
                var activeDot = $dotContainer.find('.active'),
                    visibleDots = $dotContainer.find(':not(.hidden)'),
                    direction = $(this).data('direction'),
                    nextDot;

                if (direction === 'next') {
                    nextDot = activeDot.nextAll('span:not(.hidden)').eq(0);
                    if (nextDot.length === 0) {
                        nextDot = visibleDots.eq(0);
                    }
                } else {
                    nextDot = activeDot.prevAll('span:not(.hidden)').eq(0);
                    if (nextDot.length === 0) {
                        nextDot = visibleDots.eq(nextDot.length - 1);
                    }
                }
                nextDot.trigger('click');
            });

            // keep track of touch start and end coordinates
            var touchStartX = 0,
                touchEndX = 0,
                touchStartY = 0,
                touchEndY = 0,
                isSwiping = false;

            // handler for touch start event (used for swipe)
            $heroImageContainer.on('touchstart', function (event) {
                touchStartX = event.originalEvent.changedTouches[0].screenX;
                touchStartY = event.originalEvent.changedTouches[0].screenY;
                isSwiping = false;
            });

            // Set isSwiping to true if it's a horizontal swipe
            $heroImageContainer.on('touchmove', function (event) {
                touchEndX = event.originalEvent.changedTouches[0].screenX;
                touchEndY = event.originalEvent.changedTouches[0].screenY;

                var deltaX = touchEndX - touchStartX;
                var deltaY = touchEndY - touchStartY;

                // Check if it's a horizontal swipe
                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                    isSwiping = true;
                    event.preventDefault(); // prevent scrolling if it's a swipe
                }
            });

            // handler for touch end event (used for swipe)
            $heroImageContainer.on('touchend', function (event) {
                // only carousel if it is a horizontal swipe
                if (isSwiping) {
                    var delta = touchEndX - touchStartX,
                        activeDot = $dotContainer.find('.active'),
                        visibleDots = $dotContainer.find(':not(.hidden)'),
                        nextDot;

                    if (delta >= SWIPE_THRESHOLD) {
                        // Right swipe
                        nextDot = activeDot.prevAll('span:not(.hidden)').eq(0);
                        if (nextDot.length === 0) {
                            nextDot = visibleDots.eq(nextDot.length - 1);
                        }
                        nextDot.trigger('click');
                    } else if (delta <= -SWIPE_THRESHOLD) {
                        // Left swipe
                        nextDot = activeDot.nextAll('span:not(.hidden)').eq(0);
                        if (nextDot.length === 0) {
                            nextDot = visibleDots.eq(0);
                        }
                        nextDot.trigger('click');
                    }
                }

                // Reset state
                touchStartX = 0;
                touchEndX = 0;
                touchStartY = 0;
                touchEndY = 0;
                isSwiping = false;
            });

            // handler for touch canceled event (used for swipe)
            $heroImageContainer.on('touchcancel', function () {
                touchStartX = 0;
                touchEndX = 0;
                touchStartY = 0;
                touchEndY = 0;
                isSwiping = false;
            });

            //handler for the size shown click event
            //which builds the html and displays the modal
            $container.find(selectors.modelInfoLink).on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var imageId = $(this).data('imageid'),
                    imageInfo = imagesByProductImageId[imageId];

                if (!imageInfo || !imageInfo.ModelInfo) {
                    return;
                }

                var modelInfo = imageInfo.ModelInfo;

                //build the list of attributes that will be displayed in the modal
                var attributes = [];
                for (var key in modelInfo) {
                    if (!modelInfo.hasOwnProperty(key) || !modelInfo[key]) {
                        continue;
                    }

                    var dt = $('<dt></dt>').html(key),
                        dd = $('<dd></dd>').html(modelInfo[key]);
                    attributes.push(dt.add(dd));
                }

                if (!attributes.length) {
                    return;
                }

                //make two columns of all the properties to display
                //try to make the columns equal in the number of properties
                var col1 = $('<dl class="pdp-model-info-list spec-list"></dl>'),
                    col2 = attributes.length > 1 ? col1.clone() : '',
                    midpoint = Math.ceil(attributes.length / 2);
                col1.append(attributes.slice(0, midpoint));
                if (midpoint < attributes.length && attributes.length > 1) {
                    col2.append(attributes.slice(midpoint));
                }

                var $sizeShownContainer = $container.find(selectors.modelInfoContainer),
                    $sizeShownDetails = $sizeShownContainer.find(selectors.modelInfoDetails);

                $sizeShownDetails.empty().append(col1).append(col2);
                $sizeShownContainer.addClass('active');

                $(document).one('click', function () {
                    $sizeShownContainer.removeClass('active');
                });
            });

            //close the size shown container when the "X" is clicked
            $container.find(selectors.modelInfoClose).on('click', function () {
                $container.find(selectors.modelInfoContainer).removeClass('active');
            });

            //allow users to interact with the text of the size shown modal
            $container.find(selectors.modelInfoContainer).on('click', function (e) {
                e.stopPropagation();
            });

            //function to check if we have alt images then show the mobile nav arrows
            function heroArrowsCheck() {
                var heroArrowsNeeded = $container.find(selectors.dotContainer + ' ' + selectors.imageAssets + ':not(.hidden)').length > 1;
                $container.find(selectors.pdpHeroArrows).toggleClass('active', heroArrowsNeeded);
            }

            //attach the zoom behavior to the zoom link
            $container.find(selectors.zoomLink).click(function (e) {
                e.preventDefault();
                $container.find(selectors.heroContainer + ' ' + selectors.imageAssets + '.active' + selectors.pdpHeroImage).trigger('click');
            });
        });

        //handle for default selection if a value was passed from the results page
        (function (hash) {
            //read the value of the hash parameter in the url
            var index = hash.indexOf('image=');

            if (index === -1) {
                return;
            }

            var imageToSelect = hash.slice(index + 6);

            //in case there are more parameters in the hash, get only the value we're interested in
            index = imageToSelect.indexOf('&');
            if (index > 0) {
                imageToSelect = imageToSelect.substring(0, index);
            }

            var targetImageButton = $(selectors.matrixOptionButtons).has('img[src$="' + imageToSelect + '"]').find(selectors.matrixOptions);

            if (!targetImageButton.size()) {
                return;
            }

            //if the select parameter was also passed, we should select our target button by default,
            //otherwise simply get the image to show up
            if (hash.indexOf('select=') >= 0) {
                targetImageButton.prop('checked', 'checked');
                targetImageButton.trigger('change');
            } else {
                targetImageButton.trigger('matrixoptionchanged.evo');
            }
        })(window.location.hash);
    };

    //sets up scrolling and height on the alt images and their container
    function initializeAltContainer() {
        var $altImageContainer = $(selectors.altImageContainer),
            $altImageInner = $(selectors.altImageInner),
            $altThumb = $altImageInner.find(selectors.imageAssets),
            $arrowDown = $('.js-pdp-alt-arrow-down'),
            $arrowUp = $('.js-pdp-alt-arrow-up'),
            heroHeight = $(selectors.heroContainer).find(selectors.imageContainer + ':eq(0)').outerHeight(),
            scrollPadding = 80,
            altThumbsHeight = $altThumb.eq(0).outerHeight(true) * $altThumb.length + scrollPadding,
            scrollDistance = altThumbsHeight - heroHeight,
            scrollMultiplier = 2000; //milliseconds to scroll through one page of alt thumbs,

        function initilizeAltScroll() {
            $arrowDown.hover(function () {
                    //calculate the remaining space to scroll
                    var scrollRemaining = altThumbsHeight - heroHeight - $altImageInner.scrollTop();
                    var scrollSpeed = scrollRemaining / heroHeight * scrollMultiplier;

                    $altImageInner.animate({scrollTop: scrollDistance}, scrollSpeed, 'linear');
                },
                function () {
                    $altImageInner.stop();
                });

            $arrowUp.hover(function () {
                    //base on the scrollTop of the div here
                    var scrollRemaining = $altImageInner.scrollTop() + scrollPadding;
                    var scrollSpeed = scrollRemaining / heroHeight * scrollMultiplier;

                    $altImageInner.animate({scrollTop: 0}, scrollSpeed, 'linear');
                },
                function () {
                    $altImageInner.stop();
                });
        }

        if (altThumbsHeight > heroHeight) {
            $altImageContainer.height(heroHeight).addClass('scrollable');
            if (!Modernizr.touch) {
                initilizeAltScroll();
            }
        } else {
            $altImageContainer.height('auto').removeClass('scrollable');
            $arrowDown.off('hover');
            $arrowUp.off('hover');
        }
    }

    //need to adjust on resize because we might have to hide or show alt image navigation arrows
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeAltContainer, 500);
    });
})(jQuery);